/**
 * @generated SignedSource<<2cbb358004191f2a1bb98225337000de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespNullSearchResults_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedNullSearchRelatedItems_viewer" | "SbSharedRecommendedItems_viewer" | "SharedRecentSales_viewer" | "SharedRecentlyFavoritedItems_viewer">;
  readonly " $fragmentType": "SbRespNullSearchResults_viewer";
};
export type SbRespNullSearchResults_viewer$key = {
  readonly " $data"?: SbRespNullSearchResults_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespNullSearchResults_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespNullSearchResults_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedNullSearchRelatedItems_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRecentlyFavoritedItems_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRecommendedItems_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRecentSales_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "4073ea2046cbbbc26ffac9a281a20757";

export default node;
